import config from '../../authentication/config';
import { AUTHENTICATION_TYPE } from './authenticationType';
import { authenticationTypeStore } from './autheticationTypeStore';
import { isIframeMode } from './isIframeMode';

export const isMessageBasedAuth = () => {
    const authType = authenticationTypeStore.getValue() || config.getAuthenticationType();
    return isIframeMode() && authType === AUTHENTICATION_TYPE.MESSAGE_BASED;
};
